import ApiModel from './globals/ApiModel';

export default class ContactModel extends ApiModel {
  static get path() {
    return '/backend/contacts/{?id}';
  }
}
